import { render } from "./ImageCapital.vue?vue&type=template&id=528bfd1d&scoped=true"
import script from "./ImageCapital.vue?vue&type=script&lang=js"
export * from "./ImageCapital.vue?vue&type=script&lang=js"

import "./ImageCapital.vue?vue&type=style&index=0&id=528bfd1d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528bfd1d"]])

export default __exports__